import { render, staticRenderFns } from "./UserNameCardSkeleton.vue?vue&type=template&id=71c65bb6&scoped=true&"
import script from "./UserNameCardSkeleton.vue?vue&type=script&lang=js&"
export * from "./UserNameCardSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c65bb6",
  null
  
)

export default component.exports